import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useOrganization, isPlanActive } from '@/hooks/useOrganization';

// Landing autenticado: si el usuario NO tiene membresía activa, lo manda a Plan y
// créditos (/plan) para elegir plan. Si la tiene, muestra el home normal (Dashboard).
export default function MembershipHome({ children }: { children: ReactNode }) {
  const { data: org, isLoading, isError } = useOrganization();
  if (isLoading || isError) return null;
  if (!isPlanActive(org, ['guionista', 'indie', 'pase', 'line-producer', 'productora', 'estudio'])) return <Navigate to="/plan" replace />;
  return <>{children}</>;
}
